export let subItemProps = {
    key: 0,
    id: 0,
    sub_category_name: '',
    tally_sub_group_id: null
}

export let dataProps = {
    id: 0,
    category_name: '', 
    tally_group_id: null,
    sub_item_list: [JSON.parse(JSON.stringify(subItemProps))],
    deleted_sub_item_list_items: []
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseCategory/properties.js